import React from 'react'
import { getLocalStorage } from 'config/appConfig'
import { customerContainer } from 'src/models'
import {
  currencyFormat,
  i18nTranslate,
  isEligibleToShowPVCVSV,
  stripCurrencySymbol,
} from 'src/utils'

const getPrice = (custompriceValue = 0) => {
  const formattedPrice = currencyFormat({
    price: custompriceValue,
  })
  const formattedCustomPrice = stripCurrencySymbol(formattedPrice)
  return formattedCustomPrice
}

const PVCV = ({ priceFacets = {}, isTotal = false, oneTime = false }) => {
  const localvalue = getLocalStorage('accountType') || ''

  if (
    !isEligibleToShowPVCVSV({
      accountType: localvalue,
      gateBrandAffiliate: false,
    })
  )
    return null
  const CVPriceDis =
    (oneTime || isTotal
      ? priceFacets?.CV?.CVAfterDiscount
      : priceFacets?.['Sub CV']?.['Sub CVAfterDiscount'] ||
        priceFacets?.CV?.CVAfterDiscount) || 0
  const PVPriceDis =
    (oneTime || isTotal
      ? priceFacets?.PV?.PVAfterDiscount
      : priceFacets?.['Sub PV']?.['Sub PVAfterDiscount'] ||
        priceFacets?.PV?.PVAfterDiscount) || 0

  const CVTotalPrice = getPrice(CVPriceDis)
  const PVTotalPrice = getPrice(PVPriceDis)

  const userRole = customerContainer?.profileResponse?.userrole || ''

  const SVLabel = isTotal
    ? i18nTranslate('price.TotalSV', 'Total SV', {
        nameSpace: 'ssr-resource',
      })
    : i18nTranslate('cart.itemTotalSV', 'SV')
  const CVLabel = isTotal
    ? i18nTranslate('summary.totalcv', 'Total CV')
    : i18nTranslate('cart.itemTotalCV', 'CV')

  return (
    <>
      {isTotal ? (
        <table className="sub-sum-price-table">
          {PVTotalPrice && (
            <tr>
              <td>{SVLabel}</td>
              <td>{PVTotalPrice}</td>
            </tr>
          )}
          {CVTotalPrice && (
            <>
              {userRole !== 'ROLE_ACCOUNT_BUYER_ADMIN' && (
                <tr>
                  <td>{CVLabel}</td>
                  <td>{CVTotalPrice}</td>
                </tr>
              )}
            </>
          )}
        </table>
      ) : (
        <div className="pv-cv-wrapper" data-testid="qa-subscription-sv">
          {PVTotalPrice && (
            <p>
              {SVLabel} :<span className="pl-1">{PVTotalPrice}</span>
            </p>
          )}
          {CVTotalPrice && (
            <>
              {userRole !== 'ROLE_ACCOUNT_BUYER_ADMIN' && (
                <p>
                  {CVLabel} :<span className="pl-1">{CVTotalPrice}</span>
                </p>
              )}
            </>
          )}
        </div>
      )}
    </>
  )
}

export { PVCV }
export default PVCV
